import React from 'react'
import styled from 'styled-components';
import { TitleHeader } from '../TitleHeader';
import UserLoginContinuity from './SessionUser/SessionUser';



const Container = styled.div`
  width: 100%;
  margin-top: 2rem;
 
`

const Session = styled.div`
  width: 90%;
  background-color: #F9F9F9;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 1px 1px 5px 1px #00000029;
 
`

const PatientContinuity = () => {
  return (
    <div>
      <Container>
        <TitleHeader title='CONTINÚA TU CITA'/>
        <Session>
          <UserLoginContinuity/>
        </Session>
      </Container>
    </div>
  );
};

export default PatientContinuity;
